import React from 'react';
import { Product } from '../../types/product';
import styles from '../../styles/shared/CardGrid.module.css';

interface ProductCardProps {
  product: Product;
  onEdit: (product: Product) => void;
  onDelete: (productId: number) => void;
  canEdit?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, onEdit, onDelete, canEdit = true }) => {
  const productName = product.name || product.product_name;
  const productDescription = product.description || product.product_description;
  const imageUrl = product.image_url;

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={productName}
            className={styles.cardImage}
            onError={(e) => {
              e.currentTarget.src = '/placeholder-product.jpg';
            }}
          />
        ) : (
          <div className={styles.placeholderImage}>
            <span>📦</span>
          </div>
        )}
      </div>
      
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{productName}</h3>
        
        {productDescription && (
          <p className={styles.cardDescription}>{productDescription}</p>
        )}
        
        {product.price && (
          <p className={styles.cardPrice}>${product.price.toFixed(2)}</p>
        )}
        
        {product.category && (
          <p className={styles.cardCategory}>{product.category.category_name}</p>
        )}
        
        {canEdit && (
          <div className={styles.cardActions}>
            <button 
              onClick={() => onEdit(product)} 
              className={`${styles.cardActionButton} ${styles.cardEditButton}`}
            >
              Edit
            </button>
            <button 
              onClick={() => onDelete(product.id)} 
              className={`${styles.cardActionButton} ${styles.cardDeleteButton}`}
            >
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard; 